<template>
  <b-container>
    <b-row class="mt-2 mb-2">
      <b-col>
        <hr size=1 style="background-color:#CCC;">
      </b-col>
    </b-row>
    <b-row align-h="center">
      <b-col cols="12" class="text-center">
        <b-link to="/home"><img src="@/art/logo.png" class="fluid" style="max-width:180px;" /></b-link>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="text-center">
        <b-link href="https://www.facebook.com/VivaLearningOfficial/" target="_blank" title="Facebook"><img src="@/art/facebook_150x150.png" class="social" /></b-link>
        <b-link href="https://www.instagram.com/vivalearning/?hl=en" class="pl-4 pr-4" target="_blank" title="Instagram"><img src="@/art/instagram_150x150.png" class="social" /></b-link>
        <b-link href="https://twitter.com/vivalearning?lang=en" target="_blank" title="Twitter"><img src="@/art/twitter2_150x150.png" class="social" /></b-link>
      </b-col>
    </b-row>
    <b-row class="mt-3 mb-3">
      <b-col class="text-center">
        <b-link to="/privacy">Privacy Policy</b-link>
        &nbsp;&nbsp;&bull;&nbsp;&nbsp;
        <b-link to="/terms">Terms &amp; Conditions</b-link>
      </b-col>
    </b-row>
    <b-row class="mt-3 mb-4">
      <b-col class="text-center">
        &copy; {{(new Date).getFullYear()}}  Viva Learning LLC
        <div>All rights reserved.</div>
      </b-col>
    </b-row>
    <b-row class="mt-3 mb-3">
      <b-col class="text-center">
        Version: {{version}}
        &nbsp;&nbsp;&bull;&nbsp;&nbsp;
        Build: {{build}}
      </b-col>
    </b-row>
    <b-row v-if="debug" class="mt-3 mb-3">
      <b-col cols="12" sm="6" class="text-center">
        Apple: {{utils.isApple()}}
        &nbsp;&nbsp;&bull;&nbsp;&nbsp;
        Android: {{utils.isAndroid()}}
      </b-col>
      <b-col cols="12" sm="6" class="text-center">
        Mobile: {{utils.isMobile()}}
        &nbsp;&nbsp;&bull;&nbsp;&nbsp;
        Desktop: {{utils.isDesktop()}}
      </b-col>
    </b-row>
    <CookieBanner></CookieBanner>
  </b-container>
</template>
<script>
/* eslint-disable */
// import router from "../router"
import utils from "@/utils/utils"
import CookieBanner from "@/components/CookieBanner"

export default {
    name: "FooterBar",
    data() {
        return {
            debug: false,
            utils: utils
        };
    },
    components: {
      "cookie-banner": CookieBanner
    },
    computed: {
        isLoggedIn() {
            return this.$root.hasToken();
        },
        token() {
            return this.$root.getToken();
        },
        version() { return this.$root.getVersion(); },
        build() { return this.$root.getBuild(); }
    },
    methods: {
        logout(e) {
            if (window.confirm('Are you sure you want to log out?')) {
                this.$router.push("/logout");
            }
        }
    },
    mounted() { },
    components: { CookieBanner }
};
</script>

<style scoped>
.social {
  height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/FooterBar.vue